(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hov-best-sellers"] && !Shopify.designMode) return;
  try {
    
/* Best sellers — favourites toggle (visual) + quick add via /cart/add.js.
   Post-add opens the theme's cart drawer (mirrors ProductForm in
   assets/theme.js: dispatch cart:grouped-sections to collect section ids,
   POST the add with sections + sections_url, fetch /cart.js, publish
   FoxTheme cartUpdate with the rendered sections attached, then
   drawer.show(trigger)). Fallbacks: no drawer/pubsub → update the cart
   count bubbles and flash "Added ✓" on the button; any failure after a
   successful add → hard-navigate to /cart so an add is never silently
   lost. Delegated on document so theme-editor re-renders never need
   re-binding. All data comes from data-attributes — no Liquid in here. */
(function () {
  if (window.hovBsReady) return;
  window.hovBsReady = true;

  function updateCartCounts(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var label = cart.item_count > 99 ? '99+' : String(cart.item_count);
    document.querySelectorAll('cart-count, [data-cart-count], .cart-count-bubble').forEach(function (el) {
      el.textContent = label;
      if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', cart.item_count);
    });
  }

  function flashAdded(btn, restLabel) {
    if (!btn) return;
    btn.textContent = 'Added ✓';
    setTimeout(function () {
      btn.textContent = restLabel;
    }, 1600);
  }

  /* Add `items` and open the cart drawer. Rejects ONLY when the
     /cart/add.js POST itself fails (err.hovAddFailed) — the caller keeps
     its existing error handling for that. Any error after a successful
     add resolves by navigating to /cart instead. */
  function drawerAdd(items, trigger, restLabel) {
    var drawer = document.querySelector('cart-drawer');
    var pubsub = window.FoxTheme && window.FoxTheme.pubsub;
    var canDrawer = !!(
      drawer && typeof drawer.show === 'function' &&
      pubsub && typeof pubsub.publish === 'function' &&
      pubsub.PUB_SUB_EVENTS && pubsub.PUB_SUB_EVENTS.cartUpdate
    );

    var body = { items: items };
    if (canDrawer) {
      try {
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        if (sectionsToBundle.length) {
          body.sections = sectionsToBundle.join(',');
          body.sections_url = window.location.pathname;
        }
      } catch (err) { /* bundled section rendering is optional */ }
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) {
          var err = new Error('Add to cart failed: ' + res.status);
          err.hovAddFailed = true;
          throw err;
        }
        return res.json().catch(function () { return {}; });
      })
      .then(function (added) {
        /* From here the add HAS succeeded — never lose it. */
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (canDrawer) {
              cart.sections = added.sections || {};
              pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
              drawer.show(trigger || null);
            } else {
              updateCartCounts(cart);
              flashAdded(trigger, restLabel);
            }
          })
          .catch(function () {
            window.location.href = '/cart';
          });
      });
  }

  document.addEventListener('click', function (e) {
    var fav = e.target.closest('button[data-hov-bs-fav]');
    if (fav) {
      e.preventDefault();
      var pressed = fav.getAttribute('aria-pressed') === 'true';
      fav.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      return;
    }

    var btn = e.target.closest('button[data-hov-bs-add]');
    if (!btn || btn.hasAttribute('data-hov-bs-busy')) return;
    e.preventDefault();

    var id = parseInt(btn.getAttribute('data-hov-bs-add'), 10);
    var fallbackUrl = btn.getAttribute('data-hov-bs-url');
    if (!id) {
      if (fallbackUrl) window.location.href = fallbackUrl;
      return;
    }

    var restLabel = btn.textContent;
    btn.setAttribute('data-hov-bs-busy', '');
    btn.textContent = btn.getAttribute('data-hov-bs-adding') || restLabel;

    drawerAdd([{ id: id, quantity: 1 }], btn, restLabel)
      .then(function () {
        btn.removeAttribute('data-hov-bs-busy');
        if (btn.textContent !== 'Added ✓') btn.textContent = restLabel;
      })
      .catch(function (err) {
        btn.removeAttribute('data-hov-bs-busy');
        btn.textContent = restLabel;
        if (err && err.hovAddFailed) {
          /* The add itself failed — existing behaviour: send to the PDP. */
          if (fallbackUrl) window.location.href = fallbackUrl;
        } else {
          /* Unexpected failure — never let an add die silently. */
          window.location.href = '/cart';
        }
      });
  });

  document.addEventListener('shopify:section:load', function () {
    /* Listeners are delegated on document, so re-rendered sections work
       without re-binding. Nothing else to initialise. */
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hov-inspired"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__hovInspiredInit) return;
  window.__hovInspiredInit = true;

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-hov-inspired]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.hovInspiredReady === 'true') return;
      root.dataset.hovInspiredReady = 'true';

      var input = root.querySelector('[data-hov-inspired-input]');
      var rows = root.querySelectorAll('[data-hov-inspired-row]');
      var empty = root.querySelector('[data-hov-inspired-empty]');
      if (!input || !rows.length) return;

      function filter() {
        var q = (input.value || '').trim().toLowerCase();
        var visible = 0;
        Array.prototype.forEach.call(rows, function (row) {
          var text = (row.textContent || '').toLowerCase();
          if (q === '' || text.indexOf(q) !== -1) {
            row.removeAttribute('hidden');
            visible++;
          } else {
            row.setAttribute('hidden', 'hidden');
          }
        });
        if (empty) {
          if (visible === 0) {
            empty.removeAttribute('hidden');
          } else {
            empty.setAttribute('hidden', 'hidden');
          }
        }
      }

      input.addEventListener('input', filter);
      input.addEventListener('search', filter);
    });
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hov-related"] && !Shopify.designMode) return;
  try {
    
/* Related products — standard Shopify recommendations lazy-load + quick add.
   The shell carries data-url (product recommendations endpoint, section_id =
   this section). Fetch it, parse the re-rendered section out of the response
   and swap the content in. Empty response → storefront section stays hidden;
   in the editor the placeholder cards are kept.

   Post-add opens the theme's cart drawer (mirrors ProductForm in
   assets/theme.js: dispatch cart:grouped-sections to collect section ids,
   POST the add with sections + sections_url, fetch /cart.js, publish
   FoxTheme cartUpdate with the rendered sections attached, then
   drawer.show(trigger)). Fallbacks: no drawer/pubsub → update the cart
   count bubbles and flash "Added ✓" on the button; any failure after a
   successful add → hard-navigate to /cart so an add is never silently
   lost. All data comes from data-attributes — no Liquid in here. */
(function () {
  if (window.hovRelReady) return;
  window.hovRelReady = true;

  function updateCartCounts(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var label = cart.item_count > 99 ? '99+' : String(cart.item_count);
    document.querySelectorAll('cart-count, [data-cart-count], .cart-count-bubble').forEach(function (el) {
      el.textContent = label;
      if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', cart.item_count);
    });
  }

  function flashAdded(btn, restLabel) {
    if (!btn) return;
    btn.textContent = 'Added ✓';
    setTimeout(function () {
      btn.textContent = restLabel;
    }, 1600);
  }

  /* Add `items` and open the cart drawer. Rejects ONLY when the
     /cart/add.js POST itself fails (err.hovAddFailed) — the caller keeps
     its existing error handling for that. Any error after a successful
     add resolves by navigating to /cart instead. */
  function drawerAdd(items, trigger, restLabel) {
    var drawer = document.querySelector('cart-drawer');
    var pubsub = window.FoxTheme && window.FoxTheme.pubsub;
    var canDrawer = !!(
      drawer && typeof drawer.show === 'function' &&
      pubsub && typeof pubsub.publish === 'function' &&
      pubsub.PUB_SUB_EVENTS && pubsub.PUB_SUB_EVENTS.cartUpdate
    );

    var body = { items: items };
    if (canDrawer) {
      try {
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        if (sectionsToBundle.length) {
          body.sections = sectionsToBundle.join(',');
          body.sections_url = window.location.pathname;
        }
      } catch (err) { /* bundled section rendering is optional */ }
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) {
          var err = new Error('Add to cart failed: ' + res.status);
          err.hovAddFailed = true;
          throw err;
        }
        return res.json().catch(function () { return {}; });
      })
      .then(function (added) {
        /* From here the add HAS succeeded — never lose it. */
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (canDrawer) {
              cart.sections = added.sections || {};
              pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
              drawer.show(trigger || null);
            } else {
              updateCartCounts(cart);
              flashAdded(trigger, restLabel);
            }
          })
          .catch(function () {
            window.location.href = '/cart';
          });
      });
  }

  function loadRecommendations() {
    var roots = document.querySelectorAll('[data-hov-rel]:not([data-hov-rel-loaded])');
    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-hov-rel-loaded', '');
      var url = root.getAttribute('data-url');
      if (!url) return;

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('Recommendations fetch failed: ' + res.status);
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fetched = doc.querySelector('[data-hov-rel] [data-hov-rel-content]');
          var target = root.querySelector('[data-hov-rel-content]');
          if (fetched && target && fetched.firstElementChild) {
            target.innerHTML = fetched.innerHTML;
            root.removeAttribute('hidden');
          } else if (!root.hasAttribute('data-hov-rel-editor')) {
            /* No recommendations for this product — render nothing. */
            root.setAttribute('hidden', '');
          }
        })
        .catch(function () {
          /* Leave the section as rendered (hidden shell / editor placeholders). */
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRecommendations);
  } else {
    loadRecommendations();
  }

  document.addEventListener('shopify:section:load', function () {
    /* Editor re-renders drop the loaded flag with the old node — fetch again. */
    loadRecommendations();
  });

  /* Quick add — delegated on document so swapped-in content needs no re-binding. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-hov-rel-add]');
    if (!btn || btn.hasAttribute('data-hov-rel-busy')) return;
    e.preventDefault();

    var id = parseInt(btn.getAttribute('data-hov-rel-add'), 10);
    var fallbackUrl = btn.getAttribute('data-hov-rel-url');
    if (!id) {
      if (fallbackUrl) window.location.href = fallbackUrl;
      return;
    }

    var restLabel = btn.textContent;
    btn.setAttribute('data-hov-rel-busy', '');
    btn.textContent = btn.getAttribute('data-hov-rel-adding') || restLabel;

    drawerAdd([{ id: id, quantity: 1 }], btn, restLabel)
      .then(function () {
        btn.removeAttribute('data-hov-rel-busy');
        if (btn.textContent !== 'Added ✓') btn.textContent = restLabel;
      })
      .catch(function (err) {
        btn.removeAttribute('data-hov-rel-busy');
        btn.textContent = restLabel;
        if (err && err.hovAddFailed) {
          /* The add itself failed — existing behaviour: send to the PDP. */
          if (fallbackUrl) window.location.href = fallbackUrl;
        } else {
          /* Unexpected failure — never let an add die silently. */
          window.location.href = '/cart';
        }
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hov-ritual"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Post-add flow: open the theme's cart drawer (mirrors ProductForm in
     assets/theme.js: dispatch cart:grouped-sections to collect section
     ids, POST the add with sections + sections_url, fetch /cart.js,
     publish FoxTheme cartUpdate with the rendered sections attached,
     then drawer.show(trigger)). Fallbacks: no drawer/pubsub → update the
     cart count bubbles and flash "Added ✓" on the button; any failure
     after a successful add → hard-navigate to the cart page so an add is
     never silently lost. Rejects ONLY when the add POST itself fails
     (err.hovAddFailed) — the caller keeps its error-message handling. */
  function hovRitualUpdateCounts(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var label = cart.item_count > 99 ? '99+' : String(cart.item_count);
    document.querySelectorAll('cart-count, [data-cart-count], .cart-count-bubble').forEach(function (el) {
      el.textContent = label;
      if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', cart.item_count);
    });
  }

  function hovRitualDrawerAdd(addUrl, cartUrl, items, trigger) {
    var drawer = document.querySelector('cart-drawer');
    var pubsub = window.FoxTheme && window.FoxTheme.pubsub;
    var canDrawer = !!(
      drawer && typeof drawer.show === 'function' &&
      pubsub && typeof pubsub.publish === 'function' &&
      pubsub.PUB_SUB_EVENTS && pubsub.PUB_SUB_EVENTS.cartUpdate
    );

    var body = { items: items };
    if (canDrawer) {
      try {
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        if (sectionsToBundle.length) {
          body.sections = sectionsToBundle.join(',');
          body.sections_url = window.location.pathname;
        }
      } catch (err) { /* bundled section rendering is optional */ }
    }

    return fetch(addUrl || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) {
          var err = new Error('cart add failed: ' + res.status);
          err.hovAddFailed = true;
          throw err;
        }
        return res.json().catch(function () { return {}; });
      })
      .then(function (added) {
        /* From here the add HAS succeeded — never lose it. */
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (canDrawer) {
              cart.sections = added.sections || {};
              pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
              drawer.show(trigger || null);
              return { added: true, flashed: false };
            }
            hovRitualUpdateCounts(cart);
            return { added: true, flashed: true };
          })
          .catch(function () {
            window.location.href = cartUrl || '/cart';
            return { added: true, flashed: false };
          });
      });
  }

  function makeFormatter(currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      });
    } catch (e) {
      return { format: function (n) { return '$' + n.toFixed(2); } };
    }
  }

  function initRitual(card) {
    if (!card || card.dataset.hovRitualReady === '1') return;
    var layers = card.querySelectorAll('[data-hov-layer]');
    var totalEl = card.querySelector('[data-hov-total]');
    if (!layers.length || !totalEl) return;
    card.dataset.hovRitualReady = '1';

    var compareEl = card.querySelector('[data-hov-compare]');
    var saveRow = card.querySelector('[data-hov-save-row]');
    var saveEl = card.querySelector('[data-hov-save]');
    var addBtn = card.querySelector('[data-hov-add]');
    var errEl = card.querySelector('[data-hov-error]');
    var disc2 = parseFloat(card.dataset.disc2) || 0;
    var disc3 = parseFloat(card.dataset.disc3) || 0;
    var fmt = makeFormatter(card.dataset.currency);

    function money(cents) { return fmt.format(cents / 100); }

    function scentName() {
      var r = card.querySelector('[data-hov-scent]:checked');
      return r ? String(r.value || '').toLowerCase().trim() : '';
    }

    function variantsFor(input) {
      if (!input.dataset.variants) return null;
      try {
        var parsed = JSON.parse(input.dataset.variants);
        return Array.isArray(parsed) && parsed.length ? parsed : null;
      } catch (e) {
        return null;
      }
    }

    function pickVariant(variants, scent) {
      if (!variants) return null;
      var i;
      if (scent) {
        for (i = 0; i < variants.length; i++) {
          if (variants[i].available &&
              String(variants[i].title || '').toLowerCase().indexOf(scent) !== -1) {
            return variants[i];
          }
        }
      }
      for (i = 0; i < variants.length; i++) {
        if (variants[i].available) return variants[i];
      }
      return variants[0];
    }

    function selection() {
      var scent = scentName();
      var items = [];
      var subtotal = 0;
      var count = 0;
      layers.forEach(function (input) {
        if (!input.checked) return;
        count++;
        var v = pickVariant(variantsFor(input), scent);
        var price = v && typeof v.price === 'number'
          ? v.price
          : (parseFloat(input.dataset.price) || 0);
        subtotal += price;
        if (v && v.id) items.push({ id: v.id, quantity: 1 });
      });
      var pct = count >= 3 ? disc3 : (count === 2 ? disc2 : 0);
      var total = Math.round(subtotal * (1 - pct / 100));
      return { items: items, subtotal: subtotal, total: total, pct: pct, count: count };
    }

    function render() {
      var s = selection();
      totalEl.textContent = money(s.total);
      var discounted = s.pct > 0 && s.subtotal > 0;
      if (compareEl) {
        compareEl.hidden = !discounted;
        compareEl.textContent = money(s.subtotal);
      }
      if (saveRow && saveEl) {
        saveRow.hidden = !discounted;
        saveEl.textContent = money(s.subtotal - s.total);
      }
      if (addBtn) {
        if (s.count === 0) addBtn.setAttribute('disabled', 'disabled');
        else addBtn.removeAttribute('disabled');
      }
    }

    card.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-hov-layer], [data-hov-scent]')) render();
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (errEl) errEl.hidden = true;
        var s = selection();
        if (s.count === 0) return;
        if (!s.items.length) {
          /* No usable variant data — degrade to browsing. */
          window.location.href = card.dataset.fallbackUrl || card.dataset.cartUrl || '/cart';
          return;
        }
        addBtn.setAttribute('aria-busy', 'true');
        hovRitualDrawerAdd(card.dataset.addUrl, card.dataset.cartUrl, s.items, addBtn)
          .then(function (result) {
            addBtn.removeAttribute('aria-busy');
            if (result && result.flashed) {
              /* No drawer available — brief confirmation on the button. */
              var restLabel = addBtn.textContent;
              addBtn.textContent = 'Added ✓';
              setTimeout(function () {
                addBtn.textContent = restLabel;
              }, 1600);
            }
          })
          .catch(function (err) {
            addBtn.removeAttribute('aria-busy');
            if (err && err.hovAddFailed) {
              /* The add itself failed — existing behaviour: inline error. */
              if (errEl) errEl.hidden = false;
            } else {
              /* Unexpected failure — never let an add die silently. */
              window.location.href = card.dataset.cartUrl || '/cart';
            }
          });
      });
    }

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hov-ritual]').forEach(initRitual);
  }

  if (!window.__hovRitualInit) {
    window.__hovRitualInit = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    /* Theme editor: re-init when a section is (re)loaded. */
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
